const deviceIpAdd = 'localhost';

// Reused from the mobile app (ModulusSellMobile/src/constants/google.ts).
// Override per-deployment by setting VITE_GOOGLE_MAPS_API_KEY in the .env file.
const GOOGLE_MAPS_API_KEY =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY ||
  'AIzaSyCzyg22gHL2KY6foIfFcjP5zrao2k0WQ10';

const ENV = {
  local: {
    API_BASE_URL: `http://${deviceIpAdd}:5500/api/`,
    BUY_URL: `https://develop-buy.modulusseventeen.com/`,
    SELL_URL: `https://develop-sell.modulusseventeen.com/`,
    GOOGLE_MAPS_API_KEY,
  },
  development: {
    API_BASE_URL: 'https://develop-api.modulusseventeen.com/api/',
    BUY_URL: 'https://develop-buy.modulusseventeen.com/',
    SELL_URL: 'https://develop-sell.modulusseventeen.com/',
    GOOGLE_MAPS_API_KEY,
  },
  production: {
    API_BASE_URL: 'https://api.modulusseventeen.com/api/',
    BUY_URL: 'https://modulusbuy.com/',
    SELL_URL: 'https://modulussell.com/',
    GOOGLE_MAPS_API_KEY,
  },
  emulator: {
    API_BASE_URL: 'http://10.0.2.2:5500/api/',
    BUY_URL: `https://develop-buy.modulusseventeen.com/`,
    SELL_URL: `https://develop-sell.modulusseventeen.com/`,
    GOOGLE_MAPS_API_KEY,
  },
};

type EnvKey = keyof typeof ENV;

export const getEnvConfig = (env: EnvKey = 'development') => ENV[env];
